export default "__VITE_ASSET__BMlKrjQq__"